import { render, staticRenderFns } from "./expression.vue?vue&type=template&id=b24dfde8&scoped=true&"
import script from "./expression.vue?vue&type=script&lang=ts&"
export * from "./expression.vue?vue&type=script&lang=ts&"
import style0 from "./expression.vue?vue&type=style&index=0&id=b24dfde8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24dfde8",
  null
  
)

export default component.exports